import { BreadCrumb } from 'primereact/breadcrumb';
import { Toolbar } from 'primereact/toolbar';
import { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressFilters from '../components/Progress/ProgressFilters/ProgressFilters';
import { useAppSelector } from '../redux/hooks';
import { selectedDiagnosticReportsFilter } from '../redux/reducers/filterDiagnosticReport';
import { DiagnosticsReportWrapper } from '../components/DiagnosticsReport/DiagnosticsReportWrapper';

export const Diagnostics = () => {
  const navigate = useNavigate();
  const breadcrumbItems = [{ label: 'Monitor', command: () => navigate('/quick-data') }, { label: 'Diagnostic' }];
  const home = { icon: 'nc_icon-nc_home icon-sm', command: () => navigate('/') };
  const reportFilters = useAppSelector(selectedDiagnosticReportsFilter);

  return (
    <div className="tw-flex tw-flex-col tw-gap-y-5 tw-my-[48px] md:tw-mx-[104px] tw-mx-[40px] tw-pb-[40px]">
      <BreadCrumb model={breadcrumbItems} home={home} />
      <Toolbar role="section" className="nc_page-header" center={<h1>Diagnostic</h1>} />
      <div className="tw-flex tw-flex-col tw-items-center">
        <Suspense>
          <ProgressFilters singleClassDropdown={true} />
        </Suspense>
      </div>
      {reportFilters.classes.length === 0 || !reportFilters.roadmap?.id ? (
        <div className="nc_block">
          <h3 className="tw-text-center tw-w-full tw-text-base">
            Please use the Report Settings above to get started!
          </h3>
        </div>
      ) : (
        <div className="tw-flex tw-flex-col tw-items-center">
          <DiagnosticsReportWrapper />
        </div>
      )}
    </div>
  );
};
